import React, { useState, Fragment, useEffect } from 'react';
// import styles from "./ConTrend.module.css";
import styles from './ScheduledWebCatChange.module.css';
import { Card, Col, Input, Row, Select, Space, Spin, Table, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { fetchJsData } from '../../../../api';
import { crawl } from '../../../../api/util';
import { newApps, cardCss, tabPageCss } from './columns';
const { Text } = Typography;

const ScheduledWebCatChange = (props) => {
    const [load, setLoad] = useState(true);
    const [data, setData] = useState([]);
    const key = props.usrSch == 'Scheduled' ? 1 : props.usrSch == 'Deployed' ? 0 : 2;

    useEffect(() => {
        if (props.loader === false) {
            fetchData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.loader]);

    const fetchData = async () => {
        setLoad(true);
        const data = await fetchJsData({
            type: 'fetch',
            qry: 'fetWkWebCatChanges',
        });
        setData(data['data']);
        setLoad(false);
    };

    return (
        <div>
            {/* Card */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                <Col className="gutter-row" span={23}>
                    {!load ? (
                        <FetchTabSearch
                            submit={props.submit}
                            rel={props.rel}
                            usrRel={props.usrRel}
                            loader={props.loader}
                            usrSch={key}
                            data={data}
                            col={newApps}
                            usrSel="MODIFIED"
                        />
                    ) : (
                        <Card loading={props.loader} style={{ width: '100%', minHeight: '80vh' }}>
                            <div className={styles.spinner}>
                                <Spin size="small" />
                            </div>
                        </Card>
                    )}
                </Col>
            </Row>
        </div>
    );
};

const FetchTabSearch = (props) => {
    const [searchVal, setSearchVal] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [searchIndex, setSearchIndex] = useState([]);
    const [loading, setLoading] = useState(false);
    const currentDate = new Date();
    const today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const schData =
        props.usrSch === 1
            ? props.data.filter((item) => new Date(item.scheduled_date) >= today)
            : props.usrSch === 0
            ? props.data.filter((item) => new Date(item.scheduled_date) < today)
            : props.data;
    const schColIndicator =
        props.usrSch === 1 ? 'Scheduled Date' : props.usrSch === 0 ? 'Deployed Date' : 'Scheduled / Deployed Date';

    useEffect(() => {
        setLoading(true);

        setOrigData(schData);
        setFilteredData(schData);
        const searchInd = schData.map((user) => {
            const allValues = crawl(user);
            return { allValues: allValues.toString() };
        });
        setSearchIndex(searchInd);
        setLoading(false);
    }, [props.usrSch]);

    useEffect(() => {
        if (searchVal) {
            const reqData = searchIndex.map((user, index) => {
                if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0) return origData[index];
                return null;
            });
            setFilteredData(
                reqData.filter((user) => {
                    if (user) return true;
                    return false;
                })
            );
        } else setFilteredData(origData);
    }, [searchVal, origData, searchIndex, props.usrSch]);

    return (
        <>
            <div>
                <Row gutter={16}>
                    <Col span={24}>
                        <Card
                            title={
                                loading ? (
                                    <div>
                                        <Spin size="small" />
                                    </div>
                                ) : (
                                    <Row>
                                        <Col spane={8}>
                                            <Space size="small">
                                                <Text>
                                                    {props.usrSch === 1
                                                        ? 'Scheduled'
                                                        : props.usrSch === 0
                                                        ? 'Deployed'
                                                        : 'All'}
                                                </Text>

                                                <Text>Web Category Changes</Text>
                                            </Space>
                                        </Col>
                                    </Row>
                                )
                            }
                            loading={props.loader}
                            size="small"
                            style={{ minHeight: '80vh' }}
                            bodyStyle={cardCss}
                            headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                            extra={
                                <Row>
                                    <Col span={21}>
                                        <Input
                                            onChange={(e) => setSearchVal(e.target.value)}
                                            prefix={<SearchOutlined className="site-form-item-icon" />}
                                            placeholder="Crawl Search"
                                            allowClear
                                        />
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col className="gutter-row" span={2}>
                                        {' '}
                                        <div></div>
                                    </Col>
                                </Row>
                            }
                        >
                            <Fragment>
                                <Table
                                    rowKey="id"
                                    size="small"
                                    bordered
                                    scroll={{ x: 550, y: 900 }}
                                    style={{ margin: '2px' }}
                                    dataSource={filteredData}
                                    columns={props.col(filteredData.length, schColIndicator)}
                                    loading={loading}
                                    pagination={{
                                        pageSizeOptions: ['10', '30', '60', '100', '1000'],
                                        defaultPageSize: ['50'],
                                        showSizeChanger: true,
                                        style: tabPageCss,
                                    }}
                                />
                            </Fragment>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default ScheduledWebCatChange;
